import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'vnm-skeleton-rect',
  templateUrl: './skeleton-rect.component.html',
  styleUrls: ['./skeleton-rect.component.scss']
})
export class SkeletonRectComponent {
  @HostBinding('attr.aria-disabled') ariaDisabled = true;
  @HostBinding('attr.aria-label') ariaLabel = 'loading';

  @HostBinding('style.width')
  @Input()
  width = '100%';

  @HostBinding('style.height')
  @Input()
  height = '1em';

  @HostBinding('style.border-radius')
  @Input()
  borderRadius = '3px';

  @Input()
  @HostBinding('style.background-color')
  color = '#E0E0E0';
}
